import { Permissions } from "./Permissions";

export interface UserRole {
  name: string;
  permissions: string[];
}

export interface UserRoles {
  [key: string]: UserRole;
}

export const UserRoles: UserRoles = {
  ORGANIZATION_ADMIN: {
    name: "ORGANIZATION_ADMIN",
    permissions: [
      Permissions.CREATE_CREDIT_CARD,
      Permissions.CHARGE_CREDIT_CARD,
      Permissions.DELETE_CREDIT_CARD,
      Permissions.UPDATE_MY_CREDIT_CARD,
      Permissions.VIEW_MY_CREDIT_CARD,
      Permissions.VIEW_MY_LICENSE_REQUESTS,
      Permissions.UPDATE_MY_ORGANIZATION,
      Permissions.VIEW_MY_ORGANIZATION,
      Permissions.CREATE_USER,
      Permissions.DEACTIVATE_USERS_FROM_MY_ORGANIZATION,
      Permissions.VIEW_MY_ORGANIZATION_USERS,
      Permissions.UPDATE_MY_ORGANIZATION_USERS,
      Permissions.REQUEST_DEACTIVATION,
      Permissions.UPDATE_MY_PROJECTS,
      Permissions.MANAGE_MY_CART,
      // ensuring integrity signatures are only applied when
      // appropriate is handled by application logic in the
      // signContractForIntegrity resolver
      Permissions.SIGN_LICENSE_REQUEST_CONTRACTS,
    ],
  },
  CUSTOMER_USER: {
    name: "CUSTOMER_USER",
    permissions: [],
  },
  INTERNAL_ADMIN: {
    name: "INTERNAL_ADMIN",
    permissions: [
      Permissions.CREATE_DEACTIVATEREQUEST,
      Permissions.UPDATE_ALL_DEACTIVATEREQUEST,
      Permissions.VIEW_ALL_DEACTIVATEREQUEST,
      Permissions.UPDATE_ALL_LICENSEREQUEST,
      Permissions.VIEW_ALL_LICENSEREQUEST,
      Permissions.VIEW_ALL_LICENSETYPE,
      Permissions.EDIT_LICENSE_TYPES,
      Permissions.CREATE_ORGANIZATION,
      Permissions.UPDATE_ALL_ORGANIZATION,
      Permissions.VIEW_ALL_ORGANIZATION,
      Permissions.CREATE_USER,
      Permissions.UPDATE_ALL_CUSTOMER_USER,
      Permissions.VIEW_ALL_CUSTOMER_USER,
      Permissions.CREATE_WORK,
      Permissions.DELETE_WORK,
      Permissions.UPDATE_WORK,
      Permissions.UPLOAD_SPREADSHEET_WITH_NEW_SONGS,
      Permissions.APPROVE_ACCOUNTS,
      Permissions.DOWNLOAD_TRANSACTION_INFORMATION,
      Permissions.MANAGE_ADHOC_AGREEMENTS,
    ],
  },
  INTERNAL_SUPER_ADMIN: {
    name: "INTERNAL_SUPER_ADMIN",
    permissions: [
      Permissions.MANAGE_ALL_LICENSE_REQUESTS,
      Permissions.MANAGE_ALL_ORGANIZATIONS,
      Permissions.CREATE_DEACTIVATEREQUEST,
      Permissions.UPDATE_ALL_DEACTIVATEREQUEST,
      Permissions.VIEW_ALL_DEACTIVATEREQUEST,
      Permissions.UPDATE_ALL_LICENSEREQUEST,
      Permissions.VIEW_ALL_LICENSEREQUEST,
      Permissions.VIEW_ALL_LICENSETYPE,
      Permissions.EDIT_LICENSE_TYPES,
      Permissions.VIEW_ALL_PROJECTS,
      Permissions.CREATE_ORGANIZATION,
      Permissions.UPDATE_ALL_ORGANIZATION,
      Permissions.DELETE_ORGANIZATION,
      Permissions.VIEW_ALL_ORGANIZATION,
      Permissions.CREATE_USER,
      Permissions.UPDATE_ALL_USER,
      Permissions.VIEW_ALL_CUSTOMER_USER,
      Permissions.VIEW_ALL_INTERNAL_USER,
      Permissions.CREATE_WORK,
      Permissions.DELETE_WORK,
      Permissions.UPDATE_WORK,
      Permissions.UPLOAD_SPREADSHEET_WITH_NEW_SONGS,
      Permissions.APPROVE_ACCOUNTS,
      Permissions.DEACTIVATE_USERS_FROM_MY_ORGANIZATION,
      Permissions.VIEW_MY_ORGANIZATION_USERS,
      Permissions.UPDATE_MY_ORGANIZATION_USERS,
      Permissions.UPDATE_MY_ORGANIZATION,
      Permissions.SIGN_LICENSE_REQUEST_CONTRACTS,
      Permissions.DOWNLOAD_TRANSACTION_INFORMATION,
      Permissions.VIEW_ALL_USERS_WITH_LICENSE_REQUESTS,
      Permissions.MANAGE_ADHOC_AGREEMENTS,
    ],
  },
};
